import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import Drag from './Services/Drag/reducer';
import Drop from './Services/Drop/reducer';
import Tillagg from './Services/Tillagg/reducer';
import Contact from './Services/Contact/reducer';

export const Store = createStore(
	combineReducers({
		drag: Drag,
		drop: Drop,
		tillagg: Tillagg,
		contact: Contact
	}),
 	applyMiddleware (
 		thunkMiddleware
 	)
);


// WEBPACK FOOTER //
// ./src/store.js